<template>
  <div class="app-template-detail">
    <div class="title">
      {{ template.name }}
      <span class="icon-close pointer" @click="gotoAppTemplateCenter">
        <svg-icon icon-class="close"></svg-icon>
      </span>
    </div>
    <div class="body-wrapper" v-ps>
      <div class="body">
        <div class="heading">
          <span class="app-icon" :style="{ background: template.color }">
            <svg-icon :icon-class="template.icon ? 'app_' + template.icon : 'app'"></svg-icon>
          </span>
          <div class="info">
            <div class="app-name">{{ template.name }}</div>
          </div>
          <div class="btn-wrapper">
            <base-button @click="goPreview(template.id)">
              预览
            </base-button>
            <base-button
              v-if="template.onlyOne && template.existingAppId"
              type="primary"
              @click="open(template.existingAppId)"
            >
              打开
            </base-button>
            <base-button v-else type="primary" @click="install">
              安装
            </base-button>
          </div>
        </div>
        <div class="description">
          <div class="item">
            <div class="item-title">应用分类</div>
            <div class="content">{{ template.type }}</div>
          </div>
          <div class="item">
            <div class="item-title">应用权限</div>
            <div class="content">{{ template.priMode === "OPEN" ? "开放" : "限定" }}</div>
          </div>
          <div class="item">
            <div class="item-title">开发者</div>
            <div class="content">{{ template.companyName }}</div>
          </div>
        </div>
        <div class="group">
          <div class="group-title">模板概览</div>
          <div class="group-description" v-html="template.descInfo"></div>
          <el-carousel
            indicator-position="outside"
            :autoplay="false"
            height="460px"
            v-show="!_.isEmpty(template.imgFileList)"
          >
            <el-carousel-item v-for="item in template.imgFileList" :key="item.id">
              <img
                style="width: auto; height: auto; max-width: 100%; max-height: 100%; "
                :src="getUrlByPath(item.path)"
              />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="group">
          <div class="group-title">最近更新</div>
          <div class="latest-version">
            <div class="release">
              <div class="row">
                <div class="version">
                  {{ template.latestVersion }}
                </div>
                <div class="date">
                  {{ template.latestVersionDate }}
                </div>
              </div>
            </div>
            <div class="group-description" v-html="template.latestVersionDesc"></div>
          </div>
          <div v-if="!olderVisible">
            <el-button
              style="float: right;"
              type="text"
              v-if="_.get(template, 'versionList.length') > 1"
              @click="olderVisible = true"
            >
              更多...
            </el-button>
          </div>
          <template v-if="olderVisible">
            <div class="older-versions" v-for="(item, index) in template.versions" :key="index">
              <div class="release">
                <div class="row">
                  <div class="version">
                    {{ item.version }}
                  </div>
                  <div class="date">
                    {{ item.createAt }}
                  </div>
                </div>
              </div>
              <div class="group-description" v-html="item.descInfo"></div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAppTemplate } from "@/api/user"
import { installAppTemplate } from "@/api/userCenter/app"
import { loadingService } from "@/utils/ui"
import { getUrlByPath } from "@/utils/uploadFile"
import BaseButton from "@/components/UIComponents/Button"
import templateMode from "@/mixins/templateMode"
import store from "@/store"

export default {
  name: "appTemplateDetail",
  components: { BaseButton },
  mixins: store.getters.userInfo.userId ? [] : [templateMode],
  data() {
    return {
      templateId: this.$route.query.id,
      template: {},
      olderVisible: false,
      img: require("@/assets/images/background.png")
    }
  },
  computed: {
    curUser() {
      return this.$store.getters.userInfo || {}
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    getUrlByPath,
    refresh() {
      getAppTemplate(this.templateId).then(appTemplate => {
        this.template = Object.assign(appTemplate, appTemplate.templateInfo)
        let index = this.template.versionList.length
        this.template.descInfo = this.template.desc.replaceAll("\n", "<br>")
        this.template.latestVersion = this.template.versionList[index - 1]?.version
        this.template.latestVersionDate = this.template.versionList[index - 1]?.createAt
        this.template.latestVersionDesc = this.template.versionList[index - 1]?.desc.replaceAll(
          "\n",
          "<br>"
        )
        this.template.versions = this.template.versionList
          .reverse()
          .slice(1)
          .map(version => {
            version.descInfo = version.desc?.replaceAll("\n", "<br>")
            return version
          })
      })
    },
    gotoAppTemplateCenter() {
      this.$router.push({
        name: "app-template-center"
      })
    },
    goPreview(templateId) {
      this.$router.push({ name: "app-template-worksheet", params: { appId: templateId } })
    },
    install() {
      if (!this.curUser.companyId) {
        this.$message.error("当前尚未登录,请登录后进行此操作")
        setTimeout(() => (location.href = `/login?redirect=${this.$route.fullPath}`), 500)
        return
      }
      let loadingInstance = loadingService()
      installAppTemplate(this.templateId, true)
        .then(() => {
          this.$message.success("安装成功")
          this.$router.push({ name: "home" })
        })
        .finally(() => loadingInstance.close())
    },
    open(appId) {
      this.$router.push({
        name: "worksheet",
        params: {
          appId: appId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-template-detail {
  display: flex;
  align-items: center;
  flex-flow: column;
  height: 100%;
  .title {
    z-index: 100;
    width: 100%;
    flex-shrink: 0;
    background: #fff;
    box-shadow: 0 2px 4px 0 #d8d8d8;
    font-size: $font-size-title-first;
    border-bottom: 1px solid #e4e4e4;
    display: flex;
    align-items: center;
    height: 52px;
    padding: 0 24px;
    box-sizing: border-box;
    .icon-close {
      font-size: 18px;
      margin-left: auto;
    }
  }
  .body-wrapper {
    width: 100%;
    display: flex;
    flex-flow: column;
    align-items: center;
    .body {
      flex: 1;
      display: flex;
      width: 960px;
      background: white;
      flex-flow: column;
      box-sizing: border-box;
      padding: 40px 60px;
      .heading {
        padding: 6px 0;
        display: flex;
        align-items: center;
        .app-icon {
          width: 54px;
          height: 54px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 14px;
          font-size: 35px;
          background: #ff7373;
          color: white;
          text-align: center;
        }
        .info {
          margin-left: 24px;
          .app-name {
            font-size: 20px;
            font-weight: bold;
            color: #606266;
          }
          .tags {
            margin-top: 24px;
            .el-tag {
              margin-right: 10px;
            }
          }
        }
        .btn-wrapper {
          margin-left: auto;
        }
      }
      .description {
        display: flex;
        align-items: center;
        margin-top: 30px;
        .item {
          &:not(:last-child) {
            border-right: #dcdfe6 solid 2px;
            padding-right: 30px;
            margin-right: 30px;
          }
          .item-title {
            color: rgba(96, 98, 102, 0.7);
            font-size: 14px;
            font-weight: 400;
          }
          .content {
            margin-top: 12px;
            color: #606266;
            font-size: 14px;
            font-weight: 500;
          }
        }
      }
      .group {
        display: flex;
        flex-flow: column;
        margin-top: 50px;
        .group-title {
          color: #606266;
          font-weight: 500;
          font-size: 16px;
          height: 28px;
          line-height: 28px;
          position: relative;
          &::before {
            display: inline-block;
            content: "";
            width: 6px;
            height: 28px;
            background: #3396fa;
            border-radius: 4px;
            position: absolute;
            top: 0;
            left: -22px;
          }
        }
        .group-description {
          margin-top: 18px;
          font-size: 14px;
          word-wrap: break-word;
          color: #606266;
        }
        .el-carousel {
          margin-top: 26px;
          width: 100%;
          align-self: center;
          transform: translateZ(0);
          ::v-deep {
            .el-carousel__item.is-animating {
              border-radius: 4px;
            }
          }
        }
        .release {
          .row {
            margin-top: 18px;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .date {
            font-size: 14px;
            color: rgba(96, 98, 102, 0.7);
          }
        }
        .older-versions {
          margin-top: 22px;
        }
      }
    }
  }
  ::v-deep {
    .el-carousel__indicators--outside {
      height: 38px;
    }
    .el-carousel__indicators--outside button {
      border-radius: 50%;
      width: 10px;
      height: 10px;
      padding: 5px 0;
    }
    .el-carousel__indicator.is-active button {
      width: 14px;
      height: 14px;
      background-color: #1989fa;
      border-radius: 50%;
      padding: 7px 0;
    }
  }
}
</style>
